import styled from 'styled-components';
// import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import {pageAnimation,fadeAnimation,lineAnimation,FrameAnimation,FrameAnimationContainer} from '../Animation';
import {UseScroll} from '../components/UseScroll.js';
import ReactGoogleSlides from 'react-google-slides';

const ContactUs = () => {

const [element,controls] = UseScroll();
const [element2,controls2] = UseScroll();
const [element3,controls3] = UseScroll();

return (
    <Styledwork layout = 'position' style = {{background:"#fff"}} variants = {pageAnimation} initial = "hidden" animate="show" exit = "exit" >
        <motion.div variants= {FrameAnimationContainer}>

        
        <StyledFrame1 variants= {FrameAnimation} ></StyledFrame1>
        <StyledFrame2 variants= {FrameAnimation}></StyledFrame2>
        <StyledFrame3 variants= {FrameAnimation}></StyledFrame3>
        <StyledFrame4 variants= {FrameAnimation}></StyledFrame4>

        </motion.div>

        <StyledMovie >
            <motion.h2 variants = {fadeAnimation}> <b>Coursera</b> Product Management Project</motion.h2>
            {/* <br></br> */}
            <br></br>
            <a href="https://docs.google.com/document/d/1SsEynovIGroHl92vRq7H1ykWhCFizlXfFB4_8Hkh0RM/edit" target="_blank" rel="noreferrer">
            <motion.h3 variants = {fadeAnimation} style = {{color:"#353333"}}> In-Depth Proposal </motion.h3>
            </a>

           <motion.div variants = {lineAnimation} className="Line" ref = {element} animate = {controls} initial = 'hidden'></motion.div>

           <div className="container">
      {/* <h1>Coursera Product Redesign & New Feature Recommendations</h1> */}
      <div style={{ padding: 20 }}>
        
        <ReactGoogleSlides
          width="100%"
          // https://drive.google.com/presentation/d/1udbG4zRvrxL0OkSNspbXmBCc7om_PgwF
          slidesLink="https://docs.google.com/presentation/d/1udbG4zRvrxL0OkSNspbXmBCc7om_PgwF/edit#slide=id.ga7fe8226ec_4_6"
          slideDuration={200}
          showControls
          loop
        />
      </div>
      </div>
    
        </StyledMovie>

        <StyledMovie >
            <motion.h2 variants = {fadeAnimation}> <b>Google</b> Product Management Project</motion.h2>
            {/* <br></br> */}

           <motion.div variants = {lineAnimation} className="Line" ref = {element2} animate = {controls2} initial = 'hidden'></motion.div>

           <div className="container">
      {/* <h1>Coursera Product Redesign & New Feature Recommendations</h1> */}
      <div style={{ padding: 20 }}>
        
        <ReactGoogleSlides
          width="100%"
          slidesLink="https://docs.google.com/presentation/d/1d95Nb84QS7Fwf1efmAJrHchHcu-FTYXx0FMUyBKB0UU/edit"
          slideDuration={200}
          showControls
          loop
        />
      </div>
      </div>
    
        </StyledMovie>

        <StyledMovie >
            <motion.h2 variants = {fadeAnimation}> <b>Microsoft</b> Product Management Project</motion.h2>
            {/* <br></br> */}
            <br></br>
            <a href="https://docs.google.com/document/d/1f6J8fM8Uh5gg9g0cb8kiSCOmeg_qsxLCvA1XAZwbNuA/edit#" target="_blank" rel="noreferrer">
            <motion.h3 variants = {fadeAnimation} style = {{color:"#353333"}}> In-Depth Proposal </motion.h3>
            </a>

           <motion.div variants = {lineAnimation} className="Line" ref = {element3} animate = {controls3} initial = 'hidden'></motion.div>

           <div className="container">
      {/* <h1>Coursera Product Redesign & New Feature Recommendations</h1> */}
      <div style={{ padding: 20 }}>
        
        <ReactGoogleSlides
          width="100%"
          slidesLink="https://docs.google.com/presentation/d/1vsAto6eI6_YZU4TJtPcf9N4KyiCsLKWMivSU7YcPpyo/edit"
          slideDuration={200}
          showControls
          
        />

      </div>
      </div>
    
        </StyledMovie>
        
    </Styledwork>
)


}

const Styledwork = styled(motion.div)`
min-height: 100vh;
overflow:hidden;
padding:5rem 10rem;
@media (max-width:1020px){
padding:2rem 2rem;
}
`


const StyledMovie = styled(motion.div)`
padding-bottom:5rem;
.Line{
height:0.3rem;
background:#23d997;
margin:2rem 0rem;
}
img{
width: 100%;
height: 80vh;
object-fit:cover

/* aspect-ratio: 4/3; */
/* width:100%; */
/* height:auto; */
/* object-fit:cover;  */
}
iframe{
width: 100%;
height: 80vh;
}

`

const StyledFrame1 = styled(motion.div)`
position:fixed;
top:0;
left:-10;
width:100%;
height:100%;
background:#fffebf;
z-index:2;

`
const StyledFrame2 = styled(StyledFrame1)`
background: #ff8efb;

`

const StyledFrame3 = styled(StyledFrame1)`
background: #8eb2ff

`

const StyledFrame4 = styled(StyledFrame1)`
background: #8effa0

`

export default ContactUs;

